import { useField } from "formik";
import React from "react";
import { Dropdown, Form, Label } from "semantic-ui-react";

const formats = [
  { text: "Events - Events", key: "event.generic", value: "event.generic" },
  { text: "Events - Queue", key: "event.queue", value: "event.queue" },
  { text: "Events - Flow", key: "event.call", value: "event.call" },
  { text: "Events - Call", key: "event.action", value: "event.action" },
  { text: "Events - PBX", key: "event.pbx", value: "event.pbx" },
  {
    text: "Events - SleekTech CAD Management",
    key: "event.custom.sleektech",
    value: "event.custom.sleektech",
  },
  { text: "Events - Magenta", key: "ViVa-TAPI", value: "ViVa-TAPI" },
  {
    text: "Events - Magenta Teams",
    key: "event.magenta.teams",
    value: "event.magenta.teams",
  },
  { text: "Control - Generic", key: "ivr.generic", value: "ivr.generic" },
  { text: "Taxi - Cordic", key: "ivr.cordic", value: "ivr.cordic" },
  { text: "Taxi - Magenta", key: "ViVa-D2C", value: "ViVa-D2C" },
  { text: "Taxi - MTI", key: "ivr.mti", value: "ivr.mti" },
  { text: "Taxi - Sherlock", key: "ivr.sherlock", value: "ivr.sherlock" },
  {
    text: "Integration - Avaya R11",
    key: "integration.avayaR11",
    value: "integration.avayaR11",
  },
  {
    text: "Integration - Avaya R9",
    key: "integration.avayaR9",
    value: "integration.avayaR9",
  },
];

const WebhookTypeSelect = ({ label, onChange, ...props }: any) => {
  const [field, meta, helpers] = useField(props);

  return (
    <Form.Field>
      <label>{label}</label>
      <Dropdown
        name={field.name}
        defaultValue={field.value}
        fluid
        search
        selection
        options={formats}
        placeholder='Select Application'
        onChange={(event, { value }) => {
          helpers.setValue(value);
          onChange(value);
        }}
      />
      {meta.error && (
        <Label basic color='red' pointing>
          {meta.error}
        </Label>
      )}
    </Form.Field>
  );
};

export default WebhookTypeSelect;
